import { fenToYuan, yuanToFen } from '@jiaofa/shared-utils'
import type { ProductSpecGroup } from '@/api/product'

/** 标准规格组骨架：组本身始终展示（否则接口返回空数组时运营根本没法配置），选项严格按接口回显。 */
const STANDARD_SPEC_GROUPS: ProductSpecGroup[] = [
  { id: 'sugar', name: '可选糖', required: true, multiple: false, options: [] },
  { id: 'temperature', name: '温度偏好', required: true, multiple: false, options: [] },
  { id: 'topping', name: '精选小料', required: false, multiple: true, options: [] },
]

/**
 * 编辑商品时的回显：**组**保证齐全（接口缺的标准组补空组，自建分组原样保留），
 * **选项**严格按接口回显——不再拿「默认糖/少冰」这种前端默认值兜底。
 */
export function echoSpecGroupsForEditor(groups?: ProductSpecGroup[] | null): ProductSpecGroup[] {
  const apiGroups = (groups ?? []).map((group) => ({
    ...group,
    options: (group.options ?? []).map((option) => ({
      ...option,
      priceInFen: fenAmountToYuan(option.priceInFen) ?? 0,
      // 接口可能不带这两个字段，补上默认值，否则「启用/推荐」两个下拉会显示空白
      enabled: option.enabled !== false,
      recommended: option.recommended === true,
    })),
  }))
  const missingGroups = STANDARD_SPEC_GROUPS.filter(
    (standardGroup) => !apiGroups.some((group) => group.id === standardGroup.id),
  ).map((standardGroup) => ({ ...standardGroup, options: [] }))

  return [...apiGroups, ...missingGroups]
}

/** 保存前的规范化：丢掉没填名字的选项、补上 id、价格元转分、enabled 缺省为启用。 */
export function normalizeSpecGroupsForSave(groups?: ProductSpecGroup[] | null): ProductSpecGroup[] {
  return (groups ?? []).map((group) => ({
    ...group,
    options: (group.options ?? [])
      .filter((option) => (option.name ?? '').trim())
      .map((option) => ({
        ...option,
        id: (option.id ?? '').trim() || `option-${Date.now()}`,
        name: option.name.trim(),
        priceInFen: yuanAmountToFen(option.priceInFen) ?? 0,
        enabled: option.enabled !== false,
      })),
  }))
}

function fenAmountToYuan(amountInFen?: number): number | undefined {
  return amountInFen === undefined ? undefined : Number(fenToYuan(amountInFen))
}

function yuanAmountToFen(amountInYuan?: number | string | null): number | undefined {
  return amountInYuan === undefined || amountInYuan === null || amountInYuan === ''
    ? undefined
    : yuanToFen(amountInYuan)
}
